jQuery(function($){
  const rating = $('.input-range__item')

  if (rating) {
    $('.btn-cancel').on('click', closeModalFeedback)
    $('#send-feedback').on('click', sendFeedbackForBackend)
    $('#close-modal-feedback').on('click', closeModalFeedback)
    rating.on('click', function () {
      $('.input-range__item').each(
        function () {
          $(this).removeClass('active');
        }
      );

      const item = $(this);
      item.addClass('active');
      const rate = item.data('rate');
      sendRatingForBackend(rate)
      showModalFeedback()
    })
  }
});

function sendRatingForBackend(rate) {
  postFormWithCaptcha('rating', '/page/rating.php', {rating: rate})
}

function sendFeedbackForBackend() {
  const $textarea = $('.modal-rating-feedback__text-area')
  const message = $textarea.val()

  $textarea.val('')

  postFormWithCaptcha('feedback', '/page/feedback.php', { message })

  showModalThanks()
}

function postFormWithCaptcha(action, actionUrl, data) {
  const { pageId } = currentEnvironment
  const pagepath = window.location.pathname

  try {
    grecaptcha.ready(() => {
      grecaptcha.execute(currentEnvironment.gCaptchaSitekey, { action })
        .then((token) => $.post(actionUrl, { data,  token, pageId, pagepath }))
    })
  } catch (error) {
    console.error(error)
  }
}

function showModalFeedback() {
  $('.modal-rating-feedback').show()
}

function closeModalFeedback() {
  $('.modal-rating-feedback').hide()
  $('.feedback').show()
  $('.thanks').hide()
}

function showModalThanks() {
  $('.feedback').hide()
  $('.thanks').show()
}
